<div id="libro-iva-container">
  <!-- Tipo de comprobante -->
  <div id="invoice-type">
    <p class="subheading-01-semi-bold">Tipo de comprobante</p>
    <div id="dropdwon">
      <qr-dropdown
        [config]="this.dropdownYears"
        (change)="dropdownChange($event)"
      ></qr-dropdown>
    </div>
    <div class="error-container" *ngIf="this.errors.type">
      <qr-icon name="error" color="error-700"></qr-icon>
      <p class="paragraph-02-regular">Seleccione una opcion</p>
    </div>
  </div>

  <!-- Radio group -->
  <div id="radiogroup">
    <mat-radio-group
      id="radiobuttons"
      [(ngModel)]="this.radioButtonSelected"
      (change)="radioChange($event.value)"
    >
      <mat-radio-button color="primary" value="1">
        <p class="paragraph-02-regular">Por período de fechas</p>
      </mat-radio-button>
      <mat-radio-button color="primary" value="2">
        <p class="paragraph-02-regular">Por año y mes</p>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <!-- Radio group end -->
  <!-- Periodo seleccion -->
  <div id="period-container" *ngIf="this.radioButtonSelected == '1'">
    <div class="item-period">
      <p class="subheading-01-semi-bold">Desde</p>
      <qr-date-picker
        [config]="datePickerFrom"
        (datepickerChange)="datepickerFromChange($event)"
      ></qr-date-picker>
      <div
        class="error-container"
        *ngIf="this.errors.dateFrom && this.radioButtonSelected == '1'"
      >
        <qr-icon name="error" color="error-700"></qr-icon>

        <p class="paragraph-02-regular">Fecha "Desde" inválida</p>
      </div>
    </div>
    <div class="item-period">
      <p class="subheading-01-semi-bold">Hasta</p>
      <qr-date-picker
        [config]="datePickerTo"
        (datepickerChange)="datepickerToChange($event)"
      ></qr-date-picker>
      <div
        class="error-container"
        *ngIf="this.errors.dateTo && this.radioButtonSelected == '1'"
      >
        <qr-icon name="error" color="error-700"></qr-icon>
        <p class="paragraph-02-regular">Fecha "Hasta" inválida</p>
      </div>
    </div>
  </div>

  <!-- Periodo seleccion end -->

  <!-- año y mes -->
  <div id="month-container" *ngIf="this.radioButtonSelected == '2'">
    <div class="item-period">
      <p class="subheading-01-semi-bold">Año</p>
      <div class="dropdown-item">
        <qr-dropdown
          [config]="this.dropdownYear"
          (change)="dropdownChangeYear($event)"
          [selected]="this.yearSelected"
        ></qr-dropdown>
      </div>
      <div
        class="error-container"
        *ngIf="this.errors.dropdownDate && this.radioButtonSelected == '2'"
      >
        <qr-icon name="error" color="error-700"></qr-icon>
        <p class="paragraph-02-regular">Fecha inválida</p>
      </div>
    </div>
    <div class="item-period">
      <p class="subheading-01-semi-bold">Mes</p>
      <div class="dropdown-item">
        <qr-dropdown
          [config]="this.dropdownMonths"
          (change)="dropdownChangeMonth($event)"
          [selected]="this.monthSelected"
        ></qr-dropdown>
      </div>
    </div>
  </div>
  <!-- año y mes end -->

  <!-- Tipo de comprobante END -->
</div>
